import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiStar } from 'react-icons/fi';

/**
 * CharacterCard Component
 * Displays a single character card with avatar, name, occupation, description, and badge
 */
const CharacterCard = ({ character, type = 'predefined' }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/chat?characterId=${character.characterId}`);
  };

  const photoUrl = character.photoUrl || character.fullPhotoUrl || '/default-avatar.png';
  const displayName = character.name || 'Unknown Character';
  const displayOccupation = character.occupation || '';
  const displayDescription = character.description || character.personality?.substring(0, 100) || '';

  return (
    <div
      onClick={handleClick}
      className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-200 cursor-pointer overflow-hidden border border-gray-200"
    >
      {/* Avatar Image */}
      <div className="relative h-48 bg-gradient-to-br from-purple-400 to-blue-500">
        <img
          src={photoUrl}
          alt={displayName}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.src = '/default-avatar.png';
          }}
        />
      </div>

      {/* Character Info */}
      <div className="p-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-1 truncate flex items-center gap-1">
          {displayName}
          {type === 'custom' && <FiStar size={13} className="text-blue-400 flex-shrink-0" title="Custom character" />}
        </h3>
        
        {displayOccupation && (
          <p className="text-sm text-gray-600 mb-2 truncate">
            {displayOccupation}
          </p>
        )}
        
        {displayDescription && (
          <p className="text-sm text-gray-500 line-clamp-2">
            {displayDescription}
          </p>
        )}

        {/* Start Chat Button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleClick();
          }}
          className="mt-3 w-full bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200 text-sm"
        >
          Start Chat
        </button>
      </div>
    </div>
  );
};

export default CharacterCard;
